module.exports = __webpack_public_path__ + "static/media/sf-cover.5c193d29.png";